angular.module('homebot.services')

.service('SSOService', ['$http', 'APP_CONFIG', 'RollbarService', 'SessionService', function($http, APP_CONFIG, RollbarService, SessionService){
  return {
    lockboxWhoami: function(includeParams){
      var params = {};

      if(!SessionService.getLockboxToken()) return Promise.resolve(undefined);

      if(includeParams)
        params.include = includeParams;

      return $http.get(APP_CONFIG.SSO_API_URL+'users/whoami', {params: params})
        .then(user => {
          return user;
        })
        .catch((e) => {
          RollbarService.error('Lockbox Whoami error', e);
        });
    }
  }
}]);
